import { render } from "./H5Search.vue?vue&type=template&id=287cd64e&scoped=true"
import script from "./H5Search.vue?vue&type=script&lang=js"
export * from "./H5Search.vue?vue&type=script&lang=js"

import "./H5Search.vue?vue&type=style&index=0&id=287cd64e&scoped=true&lang=css"

import exportComponent from "C:\\Work\\huabiao-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-287cd64e"]])

export default __exports__